import React from "react";

import Layout from "app/layout/Layout";

const App = () => <Layout />;

export default App;
